import Headroom from "headroom.js";
import AOS from "aos";
import NewsSearch from "./news";

import { nav } from "./nav";
import { slider } from "./slider";
import { initTransitions } from "./transitions.js";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// ------------------------------------------------------------------------------------------------
// BOOTSTRAP INIT
// ------------------------------------------------------------------------------------------------

try {
    require("bootstrap");
} catch (e) {}

// ------------------------------------------------------------------------------------------------
// HEADROOM
// ------------------------------------------------------------------------------------------------

const header = document.querySelector(".headroom");
const navBar = document.getElementById("primaryNavigation");
const app = document.querySelector("#app");

// Initialize the Headroom library

let headroom = new Headroom(header, {
    // vertical offset in px before element is first unpinned
    offset: header.offsetHeight,
    // scroll tolerance in px before state changes
    tolerance: 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance: {
        up: 5,
        down: 0,
    },
    // css classes to apply
    classes: {
        // when element is initialised
        initial: "headroom",
        // when scrolling up
        pinned: "headroom--pinned",
        // when scrolling down
        unpinned: "headroom--unpinned",
        // when above offset
        top: "headroom--top",
        // when below offset
        notTop: "headroom--not-top",
        // when at bottom of scoll area
        bottom: "headroom--bottom",
        // when not at bottom of scroll area
        notBottom: "headroom--not-bottom",
        // when frozen method has been called
        frozen: "headroom--frozen",
    },
    // element to listen to scroll events on, defaults to `window`
    scroller: window,
    // callback when pinned, `this` is headroom object
    onPin: function () {},
    // callback when unpinned, `this` is headroom object
    onUnpin: function () {
        if (navBar.classList.contains("show")) {
            this.elem.classList.remove(this.classes.unpinned);
            this.elem.classList.add(this.classes.pinned);
        } else {
            this.elem.classList.add(this.classes.unpinned);
            this.elem.classList.remove(this.classes.pinned);
        }
    },
    // callback when above offset, `this` is headroom object
    onTop: function () {},
    // callback when below offset, `this` is headroom object
    onNotTop: function () {},
    // callback when at bottom of page, `this` is headroom object
    onBottom: function () {},
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom: function () {},
});
headroom.init();

// ------------------------------------------------------------------------------------------------
// COMPONENTS
// ------------------------------------------------------------------------------------------------

(function ($) {
    jQuery(function ($) {
        // init components
        slider($);

        nav($);

        onWindowResize($);

        $(".top-link").on("click", function (event) {
            event.preventDefault();
            window.scrollTo(0, 0);
        });

        $(window).on("resize", (event) => {
            onWindowResize($);
        });

        new NewsSearch($);
    });

    AOS.init({
        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        // offset: 120, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 500, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        once: false, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    // init transitions
    initTransitions($);

    // Refresh AOS
    AOS.refreshHard();
})(jQuery);

function onWindowResize($) {
    refreshHeaderOffset($);
}

function refreshHeaderOffset($) {
	// Our header is positioned fixed, so let's offset the app element to the headers height
    headroom.offset = header.offsetHeight;
    app.style.paddingTop = `${header.offsetHeight}px`;
}